export function validateRequiredList<T>(value: T[] | undefined | null): string {
	if (value === undefined || value === null || value.length === 0) return "This field is required";
	else return "";
}

export function validateRequiredString(str: string | undefined | null): string {
	if (!str || str.trim() === "") return "This field is required";
	else return "";
}

export function validateEmail(email: string | undefined | null): string {
	const emailRegex = /^[\w-]+(\.[\w-]+)*(\+[\w-]+)?@([\w-]+\.)+[a-zA-Z]{2,7}$/;
	if (!email || validateRequiredString(email)) return "This field is required";
	if (!emailRegex.test(email)) return "Please enter a valid email address";
	else return "";
}

export function validateFutureDate(date: Date | undefined | null): string {
	const now = new Date();
	if (!date) return "This field is required";
	if (date < now) return "Please enter a future date";
	else return "";
}

export function validateUrl(value: string | undefined | null): string {
	if (!value) return "This field is required";
	try {
		new URL(value);
		return "";
	} catch {
		return "Please enter a valid URL";
	}
}
